import React, { useEffect } from 'react'

import './styles/application.sass'

import ImageVersioning from './ImageVersioning'
import Routes from './Routes'

import { BRANDING_COLOR } from '../constants'

const KioskApp = () => {
  useEffect(() => {
    let htmlRoot = document.getElementsByTagName('html')[0]
    htmlRoot.style.setProperty('--brand-primary', BRANDING_COLOR)
  })

  return (
    <div className="main">
      <ImageVersioning>
        <React.Fragment>
          <Routes/>
        </React.Fragment>
      </ImageVersioning>
    </div>
  )
}

export default KioskApp
